import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://anadearestates.com";
const DEFAULT_IMG = "https://images.unsplash.com/photo-1679402894196-4f07f3e90b40?q=85&w=1200";

// Reusable SEO head: title, description, canonical, Open Graph, Twitter + JSON-LD.
const Seo = ({ title, description, path = "", image = DEFAULT_IMG, type = "website", jsonLd, noindex = false }) => {
  const fullTitle = title ? `${title} | Anadear Estates` : "Anadear Estates | Estate Agents in Bath — Sales, Lettings & Property Management";
  const desc = description || "Anadear Estates is Bath's independent estate agency for sales, lettings and property management across BA1 & BA2 — Royal Crescent, Bathwick, Widcombe, Lansdown, Larkhall, Combe Down & Weston. Book a free Bath property valuation today.";
  const url = `${SITE}${path}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Anadear Estates" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
